import { X } from "lucide-react";

export default function ChatHeader({ onClose }) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-[#151515]">
      <div className="flex items-center gap-3">
        <div className="relative">
          <div className="w-10 h-10 rounded-full overflow-hidden border border-[#7CFF00]">
            <img
              src="/avatar-chatbot.jpg"
              alt="Frontline FAQ Assist"
              className="w-full h-full object-cover"
            />
          </div>
          <span className="pulse-dot absolute -bottom-0.5 -right-0.5 border border-[#151515]" />
        </div>
        <div>
          <p className="font-tactical text-white uppercase tracking-widest text-sm">
            Frontline FAQ Assist
          </p>
          <p className="overline text-[10px]">Online // AI Powered</p>
        </div>
      </div>
      <button
        onClick={onClose}
        className="text-zinc-400 hover:text-[#7CFF00]"
        aria-label="Close chat"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
}
